<div class="change-password-dialog">
  <div class="change-password-dialog__header">
    <h2 class="change-password-dialog__title">Change password</h2>
  </div>

  <form [formGroup]="form" class="change-password-dialog__form" (ngSubmit)="submit()">
    <div class="change-password-field">
      <label class="change-password-field__label" for="changePasswordCurrentPassword">
        Current password <span class="text-danger">*</span>
      </label>
      <div class="change-password-field__input-wrap">
        <input id="changePasswordCurrentPassword" [type]="currentPasswordVisible ? 'text' : 'password'"
          class="form-control" formControlName="currentPassword" maxlength="30"
          placeholder="Enter current password" autocomplete="current-password"
          [ngClass]="{ 'is-invalid': isInvalid('currentPassword') }" />
        <button type="button" class="change-password-field__toggle"
          (click)="currentPasswordVisible = !currentPasswordVisible"
          [attr.aria-label]="currentPasswordVisible ? 'Hide password' : 'Show password'">
          <i [class]="currentPasswordVisible ? 'bx bxs-hide' : 'bx bxs-show'"></i>
        </button>
      </div>
      <div class="change-password-field__error" *ngIf="showFieldError('currentPassword', 'required')">
        Current password is required
      </div>
    </div>

    <div class="change-password-field">
      <label class="change-password-field__label" for="changePasswordNewPassword">
        New password <span class="text-danger">*</span>
      </label>
      <div class="change-password-field__input-wrap">
        <input id="changePasswordNewPassword" [type]="newPasswordVisible ? 'text' : 'password'"
          class="form-control" formControlName="newPassword" maxlength="30"
          placeholder="Enter new password" autocomplete="new-password"
          [ngClass]="{ 'is-invalid': isInvalid('newPassword') }" />
        <button type="button" class="change-password-field__toggle"
          (click)="newPasswordVisible = !newPasswordVisible"
          [attr.aria-label]="newPasswordVisible ? 'Hide password' : 'Show password'">
          <i [class]="newPasswordVisible ? 'bx bxs-hide' : 'bx bxs-show'"></i>
        </button>
      </div>
      <div class="change-password-field__error" *ngIf="showFieldError('newPassword', 'required')">
        New password is required
      </div>
      <div class="change-password-field__error" *ngIf="showFieldError('newPassword', 'minlength')">
        New password must be at least 6 characters long.
      </div>
      <div class="change-password-field__error" *ngIf="showFieldError('newPassword', 'sameAsCurrentPassword')">
        New password must be different from your current password.
      </div>
    </div>

    <div class="change-password-field">
      <label class="change-password-field__label" for="changePasswordConfirmPassword">
        Confirm new password <span class="text-danger">*</span>
      </label>
      <div class="change-password-field__input-wrap">
        <input id="changePasswordConfirmPassword" [type]="confirmNewPasswordVisible ? 'text' : 'password'"
          class="form-control" formControlName="confirmNewPassword" maxlength="30"
          placeholder="Re-enter new password" autocomplete="new-password"
          [ngClass]="{ 'is-invalid': isInvalid('confirmNewPassword') }" />
        <button type="button" class="change-password-field__toggle"
          (click)="confirmNewPasswordVisible = !confirmNewPasswordVisible"
          [attr.aria-label]="confirmNewPasswordVisible ? 'Hide password' : 'Show password'">
          <i [class]="confirmNewPasswordVisible ? 'bx bxs-hide' : 'bx bxs-show'"></i>
        </button>
      </div>
      <div class="change-password-field__error" *ngIf="showFieldError('confirmNewPassword', 'required')">
        Confirm password is required
      </div>
      <div class="change-password-field__error" *ngIf="showFieldError('confirmNewPassword', 'minlength')">
        Confirm password must be at least 6 characters long.
      </div>
      <div class="change-password-field__error" *ngIf="showFieldError('confirmNewPassword', 'confirmPasswordValidator')">
        Password and confirm password do not match.
      </div>
    </div>

    <div class="change-password-dialog__actions">
      <button type="button" class="change-password-dialog__cancel" [disabled]="isSubmitting" (click)="close()">
        Cancel
      </button>
      <app-button label="Change password" type="submit" variant="primary"
        [disabled]="form.invalid || isSubmitting" [loading]="isSubmitting"></app-button>
    </div>
  </form>
</div>
